'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Global error:', error);
  }, [error]);

  return (
    <html>
      <body>
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-stone-50 to-stone-100 dark:from-gray-900 dark:to-gray-800">
          <div className="text-center max-w-md mx-auto px-6 py-16">
            {/* Error Icon */}
            <div className="mb-8">
              <svg
                className="w-24 h-24 mx-auto text-forest-green-300 dark:text-forest-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>

            {/* Error Message */}
            <h1 className="text-5xl font-serif font-bold text-stone-800 mb-2 dark:text-stone-200">
              Oops!
            </h1>

            <p className="text-lg text-stone-600 mb-2 dark:text-stone-400">Something went wrong</p>
            <p className="text-stone-500 mb-8 dark:text-stone-500">
              A critical error occurred while loading the page. Try reloading or head back to the homepage.
            </p>

            {/* Action Buttons */}
            <div className="flex justify-center gap-4">
              <button
                onClick={reset}
                className="inline-block px-6 py-3 bg-gradient-to-r from-forest-green-600 to-forest-green-700 text-white rounded-md hover:from-forest-green-700 hover:to-forest-green-800 transition-colors text-sm font-medium"
              >
                Reload page
              </button>

              <a
                href="/"
                className="inline-block px-6 py-3 bg-white text-forest-green-600 border border-forest-green-600 rounded-md hover:bg-forest-green-50 transition-colors text-sm font-medium dark:bg-transparent dark:text-forest-green-400 dark:hover:bg-forest-green-900/30"
              >
                Go home
              </a>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
